import React, { useEffect, useState } from "react";
import { API_ciudadanos } from "../../config/apiConfig";
import { toast } from "react-toastify";
import { FaPenToSquare, FaRegTrashCan, FaCheck, FaX } from "react-icons/fa6";
import "../../pages/user/css/Curriculum.css";

const Habilidades = ({ usuario }) => {
  // Estado para almacenar las habilidades
  const [habilidades, setHabilidades] = useState([]);
  // Estado para la nueva habilidad
  const [nuevaHabilidad, setNuevaHabilidad] = useState("");
  // Estado para la edición
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingValue, setEditingValue] = useState("");

  useEffect(() => {
    if (usuario?.userId) {
      fetch(`${API_ciudadanos}/${usuario.userId}/curriculum`)
        .then(res => res.json())
        .then(data => {
          if (Array.isArray(data?.HobbiesAndInterests)) {
            setHabilidades(data.HobbiesAndInterests);
          }
        })
        .catch(err => console.error("Error al cargar habilidades:", err));
    }
  }, [usuario]);

  const actualizarHabilidadesEnServidor = async (nuevasHabilidades) => {
    try {
      const res = await fetch(`${API_ciudadanos}/${usuario.userId}/curriculum`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ HobbiesAndInterests: nuevasHabilidades })
      });
      if (!res.ok) throw new Error("Error al actualizar habilidades");
      toast.success("Habilidad actualizada");
    } catch (error) {
      console.error("❌ Error al actualizar habilidades:", error);
      toast.error("Error al guardar las habilidades");
    }
  };

  const handleAddHabilidad = () => {
    if (nuevaHabilidad.trim() !== "") {
      const nuevas = [...habilidades, nuevaHabilidad.trim()];
      setHabilidades(nuevas);
      setNuevaHabilidad("");
      actualizarHabilidadesEnServidor(nuevas);
    }
  };

  const handleDeleteHabilidad = (index) => {
    const nuevasHabilidades = habilidades.filter((_, i) => i !== index);
    setHabilidades(nuevasHabilidades);
    actualizarHabilidadesEnServidor(nuevasHabilidades);
  };

  const handleEditHabilidad = (index) => {
    setEditingIndex(index);
    setEditingValue(habilidades[index]);
  };

  const handleSaveEdit = (index) => {
    const nuevasHabilidades = [...habilidades];
    nuevasHabilidades[index] = editingValue.trim();
    setHabilidades(nuevasHabilidades);
    setEditingIndex(null);
    setEditingValue("");
    actualizarHabilidadesEnServidor(nuevasHabilidades);
  };

  // Cancelar edición
  const handleCancelEdit = () => {
    setEditingIndex(null);
    setEditingValue("");
  };

  return (
    <div className="habilidades caja-verde">
      <h2 className="blanco fondo-verde mayusculas">HABILIDADES</h2>
      <ul className="contenido">
        {habilidades.length > 0 ? (
          habilidades.map((habilidad, index) => (
            <li key={index} className="habilidad-item">
              {editingIndex === index ? (
                <div className="editar-habilidad between gap-5">
                  <input
                    type="text"
                    value={editingValue}
                    onChange={(e) => setEditingValue(e.target.value)}
                  />
                  <div className="check flex gap-5">
                    <button aria-label="Guardar cambios" className="fondo-blanco verde" onClick={() => handleSaveEdit(index)}><FaCheck /></button>
                    <button aria-label="Cancelar cambios" className="fondo-blanco rojo" onClick={handleCancelEdit}><FaX /></button>
                  </div>
                </div>
              ) : (
                <div className="editar-cv between">
                  {habilidad}
                  <div className="botones-guardar-cancelar">
                    <button className="fondo-blanco" aria-label="Editar esta habilidad" onClick={() => handleEditHabilidad(index)}><FaPenToSquare /></button>
                    <button className="fondo-blanco eliminar" aria-label="Eliminar esta habilidad" onClick={() => handleDeleteHabilidad(index)}><FaRegTrashCan /></button>
                  </div>
                </div>
              )}
            </li>
          ))
        ) : (
          <li className="texto-defecto">Añade habilidades</li>
        )}
      </ul>

      {/* Añadir nueva habilidad */}
      <div className="nueva-edicion-rapida flex gap-10 w-100">
        <input
          type="text"
          placeholder="Escribe una habilidad"
          value={nuevaHabilidad}
          onChange={(e) => setNuevaHabilidad(e.target.value)}
        />
        <button className="boton estrecho" onClick={handleAddHabilidad}>Añadir</button>
      </div>
    </div>
  );
};

export default Habilidades;
